import { Controller } from "@hotwired/stimulus"

// Every roman weight we ask Bunny for. Italics are rare enough in a preview to swap.
const WARMUP_WEIGHTS = ["400", "500", "600", "700", "800"]

// Declaring a face doesn't fetch it — the browser waits until something renders
// in it. Asking for the weights we paint up front means a font picked in the
// branding editor is already in cache when the preview reloads, instead of
// flashing its fallback while the file downloads.
export default class extends Controller {
  static values = { families: Array }

  connect() {
    this.familiesValue.forEach(family => {
      WARMUP_WEIGHTS.forEach(weight => {
        document.fonts.load(`${weight} 1em "${family}"`).catch(() => {})
      })
    })
  }
}
